export enum AuthenticationMode {
    IDP = 'IDP',
    GPP = 'GPP',
    SSO = 'SSO'
}
